/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener('DOMContentLoaded', function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  }

  let endTimeG

  function cutDownTime() {
    let nowTime = new Date()
    let endTime = new Date(endTimeG)

    let leftTime = endTime.getTime() - nowTime.getTime()
    if (leftTime < 0) {
      setupNewCountdown()
      leftTime = 0
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60)
    leftH = leftH >= 10 ? leftH : '0' + leftH
    leftM = leftM >= 10 ? leftM : '0' + leftM
    leftS = leftS >= 10 ? leftS : '0' + leftS

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    }
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9)
    const currentTime = new Date()
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
  }
  let intervalId

  function getCutDownTime() {
    setupNewCountdown()
    if (intervalId) clearInterval(intervalId)
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
      $('.sp_top_cut_down .sp_left_view .sp_minute').html(
        cutDownTimeText.minute
      )
      $('.sp_top_cut_down .sp_left_view .sp_second').html(
        cutDownTimeText.second
      )
    }, 1000)
  }

  getCutDownTime()

  jQuery('.sp-scroll').slide({
    mainCell: '.sp-nav-imgs',
    autoPlay: true,
    effect: 'leftMarquee',
    interTime: 12,
    vis: 2,
    scroll: 1,
  })
  let spImgList = [
    'https://cdn.shopify.com/s/files/1/0849/9606/3537/files/76964ad0badf32588df6e0f0d64365cf.webp',
    'https://cdn.shopify.com/s/files/1/0849/9606/3537/files/13c458468b4cd17ba5b03c76a4efc34a.webp',
    'https://cdn.shopify.com/s/files/1/0849/9606/3537/files/1148fc01973feccc3f2bea11255bf73b.webp',
  ]
  let spBannerList = []

  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      let scale = document.body.clientWidth / 1080
      $('#root').css('zoom', scale)

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              let scale = document.body.clientWidth / 1080
              $('#root').css('zoom', scale)
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach(subArray => {
          subArray.forEach(url => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    // preloadImages(spImgList);
    preloadImages(spBannerList)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            230 * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }
  }

  mainRender()

  var thumbsp = new Swiper('#thumbs-p', {
    direction: 'vertical',
    spaceBetween: 5,
    slidesPerView: 3,
    // slidesPerView: "auto",
    watchSlidesVisibility: true, //防止不可点击
  })

  let swiper = new Swiper('#swiper-p1', {
    thumbs: {
      swiper: thumbsp,
    },
    on: {
      slideChange: function (e) {
        $('#sp-color .option')
          .eq(e.realIndex)
          .addClass('active')
          .siblings()
          .removeClass('active')
      },
    },
    speed: 1,
    spaceBetween: 20,
  })

  //   $(".product-part .sp-num .option").click(function () {
  //     var index = $(this).index();
  //     var number = 1;
  //     var plostNumber = 0;
  //     if (index == 0) {
  //       number = 1;
  //     } else if (index == 1) {
  //       number = 3;
  //     } else if (index == 2) {
  //       number = 5;
  //     }

  //     plostNumber = Number(sp_price1 / number)
  //       .toString()
  //       .replace(/(?<=\.\d{2}).*$/, "");

  //     $(".sp-dj").html(plostNumber);
  //   });
  $('#sp-num .option').click(function () {
    var index = $(this).index()
    $(this).addClass('active').siblings().removeClass('active')
    if (index == 1) {
      let price_font = (getCur().price / 3 / 100).toFixed(2)
      $('.product-part .price3 #sp-dj').html(`${price_font}`)
    } else if (index == 2) {
      let price_font = (getCur().price / 5 / 100).toFixed(2)
      $('.product-part .price3 #sp-dj').html(`${price_font}`)
    } else {
      let price_font = (getCur().price / 1 / 100).toFixed(2)
      $('.product-part .price3 #sp-dj').html(`${price_font}`)
    }
    changePrice()
  })
  $('#sp-color .option').click(function () {
    var index = $('#sp-num .option.active').index()
    if (index == 1) {
      let price_font = (getCur().price / 3 / 100).toFixed(2)
      $('.product-part .price3 #sp-dj').html(`${price_font}`)
    } else if (index == 2) {
      let price_font = (getCur().price / 5 / 100).toFixed(2)
      $('.product-part .price3 #sp-dj').html(`${price_font}`)
    } else {
      let price_font = (getCur().price / 1 / 100).toFixed(2)
      $('.product-part .price3 #sp-dj').html(`${price_font}`)
    }
    changePrice()
  })

  //加减
  let prods = window.product
  console.log(prods, prods)
  function getCur() {
    let color = $('#sp-color div.active').attr('data-val')
    let num = $('#sp-num div.active').attr('data-val')
    return prods.filter(item => item.option1 == color && item.option2 == num)[0]
  }
  function changePrice() {
    let num = $('#calcNumber').val()
    let price = ((getCur().price * num) / 100).toFixed(2)
    let compare = ((getCur().compare_at_price * num) / 100).toFixed(2)
    // if(num == 1){
    //   price = (getCur().price * num / 100).toFixed(2)
    // }else if(num == 2){
    //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
    // }else if(num == 3){
    //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
    // }else {
    //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
    // }
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    $('#sp_price1').html(price)
    $('#sp_price2').html(compare)
    let off_font =
      100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
    $('.product-part .sp-brand p .sp-off').html(off_font)
  }
  $('.sp-btn-style').click(function () {
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur().id + ':' + num
  })

  $('.sp-reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
      changePrice()
    }
    // showTip();
  })
  $('.sp-add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    changePrice()
    // showTip();
  })

  $(function () {
    $('.option').click(function () {
      $(this).siblings().removeClass('active')
      $(this).addClass('active')
      changePrice()
      let colorOptions = $('#sp-color .option.active').index()

      swiper.slideTo(colorOptions)
      // style选项
    })
    if (window.cartCount > 0) {
      $('#cardNum').removeClass('sp-gray')
    }
    $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
      $('#cardNum').html(result.item_count)
      $('#cardNum').removeClass('sp-gray')
    })
    // 购物车加购动效
    $('.cart-btn').click(function () {
      $(this).children('img').addClass('on')
      $('.sp-header-top .sp-cart .num').show()
      setTimeout(function () {
        $('.cart-btn').children('img').removeClass('on')
      }, 500)
      $('.sp-header-top .sp-cart').addClass('on')
      setTimeout(function () {
        $('.sp-header-top .sp-cart').removeClass('on')
      }, 500)
    })
    let initNum = 0
    $('.product-part .cart-btn').click(function () {
      var data = {
        id: getCur().id,
        quantity: $('#calcNumber').val(),
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
            $('#cardNum').html(result.item_count)
            $('#cardNum').removeClass('sp-gray')
          })
        },
        dataType: 'json',
      })

      // var img = $(".product-part .p-img");
      var img = $('.product-part .sp-swiper .swiper-slide-active .sp-img')

      var flyer = img[0].cloneNode(true)
      flyer.classList.add('sp_clone')

      $('.product-part').append(flyer)
      $('.sp_clone').css({
        width: img[0].width,
        height: img[0].height,
        position: 'fixed',
        top: img[0].offsetTop,
        left: img.offset().left,
        'z-index': '99',
      })

      let finish = $('.sp-cart')
      $('.sp_clone').animate(
        {
          // top: finish[0].offsetTop,
          top: finish[0].offsetTop + $('.time-part').height(),

          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        500,
        'linear',
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach()
            }
          )
        }
      )
    })
  })
})
